import { fetchBadges, registerProductEnrichmentOptions, } from './product-enrichment-actions.js';
import { productEnrichmentReducer as productEnrichment } from './product-enrichment-slice.js';
/**
 * Loads the commerce product enrichment reducer and returns the available product enrichment action creators.
 *
 * @param engine - The headless commerce engine.
 * @returns An object holding the product enrichment action creators.
 *
 * @group Actions
 * @category ProductEnrichment
 */
export function loadProductEnrichmentActions(engine) {
    engine.addReducers({ productEnrichment });
    return {
        fetchBadges,
        registerProductEnrichmentOptions,
    };
}
